import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ContactDirectory\PreviewMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/PreviewMergeController.php
* @route '/api/contact-directory/merge/preview'
*/
const PreviewMergeController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PreviewMergeController.url(options),
    method: 'post',
})

PreviewMergeController.definition = {
    methods: ["post"],
    url: '/api/contact-directory/merge/preview',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ContactDirectory\PreviewMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/PreviewMergeController.php
* @route '/api/contact-directory/merge/preview'
*/
PreviewMergeController.url = (options?: RouteQueryOptions) => {
    return PreviewMergeController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ContactDirectory\PreviewMergeController::__invoke
* @see app/Http/Controllers/ContactDirectory/PreviewMergeController.php
* @route '/api/contact-directory/merge/preview'
*/
PreviewMergeController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: PreviewMergeController.url(options),
    method: 'post',
})

export default PreviewMergeController